import BaseContainer from "@base/container/BaseContainer";
import SpineAnimation from "@base/spineAnimation/SpineAnimation";
import TweenMax, {Expo} from "gsap";
import {Signals} from "@/Imports";
import PlaneConfig from "@/config/PlaneConfig";
import Facade from "@/Facade";
import Power2 from "gsap";
import Config from "@/config/Config";
import Utils from "@base/utils/Utils";
import BulletContainer from "./BulletContainer";

export default class PlaneContainer extends BaseContainer {

  constructor(data) {
    super(data)
    this.init()
  }

  init(data) {
    this.mainPlayerAnimations = ['MainPlayerForwardLeft', 'MainPlayerForwardRight', 'MainPlayerGetLostLeft', 'MainPlayerGetLostRight', 'MainPlayerToCameraLeft', 'MainPlayerToCameraRight']
    this.otherPlayerAnimations = ['OnlinePlayerForwardLeft', 'OnlinePlayerForwardRight', 'OnlinePlayerGetLostLeft', 'OnlinePlayerGetLostRight', 'OnlinePlayerToCameraLeft', 'OnlinePlayerToCameraRight']

    this.activeBullets = []
    this.itemsPool = []


    this.justStarted = false

    this.planeX = 0
    this.planeY = 0
    this.parachutesOnScreen = 0
    this.parachutes = []
    this.parachutesPool = []
    this.arr = PlaneConfig.plane
    Signals.startFeature.add(this.onStartFeature, this)
    Signals.stopFeature.add(this.onStopFeature, this)

    Signals.forceRoundStart.add(this.reset, this)
    Signals.makeBets.add(this.onMakeBets, this)
    Signals.roundStart.add(this.start, this)
    Signals.roundEnd.add(this.onRoundEnd, this)
    Signals.playerTakeWin.add(this.onPlayerParachute, this)

    this.parachutesContainer = new PIXI.Container()
    this.addChild(this.parachutesContainer)

    this.explosion = new SpineAnimation('ExplosionAnim')
    this.addChild(this.explosion)
    this.explosion.visible = false

    this.container = new PIXI.Container()
    this.addChild(this.container)

    this.plane = new SpineAnimation('jetAnims')
   // this.plane.visible = false
    this.container.addChild(this.plane)

    this.body = new PIXI.Sprite(PIXI.Texture.from('ShipGlowBlue'))
    this.body.anchor.set(0.5)
    this.plane.addChild(this.body)

    this.bulletsContainer = new PIXI.Container()
    this.addChild(this.bulletsContainer)
    this.bulletsContainer.position.set(-5, -70)

    this.shield = new SpineAnimation('shieldAnims')
    this.container.addChild(this.shield)
    this.shield.visible = false


    this.container.position.set(this.planeX, this.planeY)
    this.parachutesContainer.position.set(this.container.x, this.container.y)
  }

   onStartFeature() {
    console.log(Facade.model.randomTime)
     this.realStartFeatureTimer = setTimeout(() => {
       this.realStartFeature()
     }, Facade.model.randomTime)
  }

  realStartFeature() {
    TweenMax.to(this, 1, {y: Config.currentPattern.planeContainer.y + 110})

    this.shootingTimeout = setTimeout(() => {
      this.shield.visible = true
      this.shield.start(['shieldIn', 'shieldIdle'], [false, true])
      setTimeout(() => this.shooting(), 500)
    }, 2500)
    this.isShooting = true
  }

  onStopFeature() {
    clearTimeout(this.realStartFeatureTimer)
    this.realStartFeatureTimer = null

    clearTimeout(this.shootingTimeout)

    this.shield.start(['shieldAfterAttacked'], [false])

   /* setTimeout(() => {
      this.shield.visible = false
    }, 500)*/

    this.isShooting = false
    if(!this.isStoppped) {
      TweenMax.to(this, 1, {delay: 1, y: Config.currentPattern.planeContainer.y})
    }

    while (this.activeBullets.length > 0) {
      const b = this.activeBullets.pop()
      b.stop()
      this.poolBulletIn(b)
    }

    this.activeBullets.length = 0
  }

  onMakeBets() {
    TweenMax.killTweensOf(this)
    TweenMax.killChildTweensOf(this)
    this.y = Config.currentPattern.planeContainer.y

    this.container.position.set(this.planeX, this.planeY)
    this.container.visible = true
    this.plane.visible = true
    this.justStarted = true
    this.plane.start(['shipMakeBetsIdle'], [true])
    this.container.position.set(this.planeX, this.planeY)
  }

  reset() {
    this.stop()
    TweenMax.killTweensOf(this)
    TweenMax.killChildTweensOf(this)
    this.y = Config.currentPattern.planeContainer.y

    this.container.position.set(this.planeX, this.planeY)


    this.isPlaneStopped = false

    this.explosion.visible = false
    this.explosion.stop()
    //this.plane.start (['shipSwitchEngine'], [false])

    this.parachutesOnScreen = 0

    this.parachutesContainer.position.set(this.container.x, this.container.y)

    this.justStarted = true

    while (this.parachutes.length > 0) {
      this.poolIn(this.parachutes.pop())
    }
  }

  start() {
    this.container.position.set(this.planeX, this.planeY)

    this.isStoppped = false
    this.container.position.set(this.planeX, this.planeY)

    this.a = Math.round(Facade.model.deltaTime * 60)
    console.log('this.a', this.a)
    if (Facade.model.deltaTime < 0 || this.a >= this.arr.length - 1) {
      this.a = this.arr.length - 1
      const o = this.arr[this.arr.length - 1]
      this.container.y = o.y
      this.plane.start(['shipIdleBlue'], [true])

      return
    }
    Facade.soundManager.play('space_liftoff', 0.2, false, 'default')

    this.plane.start (['shipPrep', 'shipLiftsOff', 'shipIdleBlue'], [false, false, true])

    Signals.tick.add(this.update, this)

    //this.arr.length = 0
    //TweenMax.to(this.container, 4, {y: '-=100', ease: Expo.easeInOut})

  }

  stop() {
    this.isPlaneStopped = true

    Signals.tick.remove(this.update, this)

    //console.log(this.arr)
  }

  update() {
    /*const a = {
      y: Number(this.container.y.toFixed(2))
    }
    this.arr.push(a)*/

    const o = this.arr[this.a]
    this.container.y = o.y
    this.a++
    if(this.a == this.arr.length) {
      this.a = this.arr.length - 1
      this.stop()
    }
  }

  onRoundEnd() {
    this.stop()
    clearTimeout(this.realStartFeatureTimer)
    this.realStartFeatureTimer = null
    this.shield.visible = false
    this.isStoppped = true
    this.onStopFeature()

    TweenMax.killTweensOf(this)

    this.plane.visible = false

    this.explosion.visible = true
    this.explosion.position.set(this.container.position.x, this.container.position.y)
    this.explosion.start (['explosRegular'], [false])
  }

  onPlayerParachute(data) {
    let animationName = ''
    let animations = null

    if(data.i == Facade.model.betId1 || data.i == Facade.model.betId2) {
      animations = this.mainPlayerAnimations


    } else {
      animations = this.otherPlayerAnimations
    }
    animationName = animations[Utils.getRandomInt(0, animations.length - 1)]

    if(this.parachutesOnScreen >= Config.MAX_PARACHUTES_ON_SCREEN) {return}
    this.parachutesOnScreen ++
    const p = this.poolOut()
    p.visible = true
    p.start ([animationName], [false])
    this.parachutesContainer.position.set(this.container.x, this.container.y - 30)
    TweenMax.to(p, 0.5, {x: '-=100', ease: Power2.easeIn, delay: 0.2, onComplete: () => {
        TweenMax.to(p, 2, {x: '-=300', onComplete: () => {
            this.parachutesOnScreen --
          }})
      }})
    this.parachutes.push(p)

  }

  poolIn(parachute) {
    parachute.position.set(0, 0)
    parachute.stop()
    parachute.visible = false
    this.parachutesPool.push(parachute)
    parachute.stop()
  }

  poolOut() {
    if(this.parachutesPool.length == 0) {
      const p = new SpineAnimation('ParachutistsAnim')
      this.parachutesContainer.addChild(p)
      this.parachutesPool.push(p)
    }
    return this.parachutesPool.pop()
  }



  shooting() {
    this.shoot()
    this.shield.start(['shieldBeingAttacked'], [true])
  }

  shoot() {
    Facade.soundManager.play('space_player_attack', 0.1, false, 'default')

    const b = this.poolBulletOut()
    this.activeBullets.push(b)
    b.position.set(-15, -90)
    b.start()

    const b1 = this.poolBulletOut()
    this.activeBullets.push(b1)
    b1.position.set(15, -90)
    b1.start()


    if(this.isShooting) {
      setTimeout(() => {
        Facade.soundManager.play('space_boss_blast', 0.1, false, 'default')
      }, 200)

      setTimeout(this.shoot.bind(this), 250)
    }
  }

  poolBulletIn(item) {
    this.itemsPool.push(item)
    item.visible = false
  }

  poolBulletOut() {
    if(this.itemsPool.length == 0) {
      const p = new BulletContainer('rocketBullet', -1)
      this.bulletsContainer.addChild(p)
      this.itemsPool.push(p)
    }
    const p = this.itemsPool.pop()
    p.visible = true
    return p
  }


}
